import React from 'react';
import { NavLink, } from 'react-router-dom';
import {FaArrowAltCircleRight} from 'react-icons/fa';

const Dashboard = ({children}) => {
    return (
        <div className='bg-gray-100'>
            <div className="container mx-auto px-5 lg:px-0 py-10">
                <div className="grid grid-cols-4 gap-4">
                    <div className="side-nav flex flex-col bg-white py-4 px-2 shadow rounded-lg h-[150px]">
                        <NavLink className={(navData)=>navData.isActive ? "text-blue-400 font-semibold border-l-[4px] border-blue-400 pl-2 mb-2" : "mb-2 hover:text-blue-400 transition duration-300 hover:border-l-[4px] border-blue-400 pl-2 font-semibold"} to='/manage-profile'>
                            Manage Profile
                        </NavLink>
                        <NavLink className={(navData)=>navData.isActive ? "text-blue-400 font-semibold border-l-[4px] border-blue-400 pl-2 mb-2" : "mb-2 hover:text-blue-400 transition duration-300 hover:border-l-[4px] border-blue-400 pl-2 font-semibold"} to='/my-order'>
                            My Orders
                        </NavLink>
                        <NavLink className={(navData)=>navData.isActive ? "text-blue-400 font-semibold border-l-[4px] border-blue-400 pl-2 mb-2" : "mb-2 hover:text-blue-400 transition duration-300 hover:border-l-[4px] border-blue-400 pl-2 font-semibold"} to='/wishlist'>
                            My Wishlist
                        </NavLink>
                        <button className='text-left pl-2 font-semibold hover:text-blue-400 flex items-center'><FaArrowAltCircleRight/>Log Out</button>
                    </div>
                    <div className="col-span-3">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;